module.exports = __webpack_public_path__ + "img/Gagich.3e4d24c8.jpeg";